import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { numberWithCommas } from '../../../../../Utils/NumberToComma';
import {LineItemCostAllocation} from '../../Submit/MultiSubmitInvoice/CostAllocation/LineItemCostAllocation'
import { get, post } from '../../../../../Model/Network/Config/Axios';
import { handleError, showToast } from '../../../../Common/fToast/ToastCallback';
import { Modal } from '../../../../Common/fModal/Modal';
import ToggleSwitch from '../../../../Common/fSwitch';
import LineItemModal from './LineItemModal';
import BulkTdsLineItem from './BulkTdsLineItem';
import AddLineItem from './AddLineItem';
import PastInvoices from './PastInvoices';
import {useHistory} from 'react-router-dom';
import EditAdditionalCharge from './EditAdditionalCharge';
import './fInvoice.css';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import AdditionalCharges from '../../Submit/MultiSubmitInvoice/AdditionalCharges';
import DiceAiButton from './DiceAiButton';
import { AiSuggestions } from './AiSuggestions';
import { customOrder, displayKeyMap } from '../../../fVendor/VendorAdvance/AdvanceDetails/Details';
import { useVendorContactHook } from '../../../../../Utils/UseLdcHook';
import { ReadOnly } from '../../../../Common/fCard/ButtonOutline/ReadOnly';

export const sortAndMapForms = (forms, orderMap = customOrder, displayMap = displayKeyMap) => {
    if (!forms || !Array.isArray(forms)) return [];
    
    // Filter out duplicates based on key using Map (O(n) complexity)
    const uniqueForms = Array.from(
        new Map(forms.map(form => [form.key, form])).values()
    );
    
    return [...uniqueForms]
        .sort((a, b) => {
            const aIndex = orderMap.indexOf(a.key);
            const bIndex = orderMap.indexOf(b.key);
            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;
            return aIndex - bIndex;
        })
        .map(item => ({
            ...item,
            displayKey: displayMap[item.key] || item.key
        }));
};

function Invoice(props){

    
    const [open,setOpen] = useState(undefined);
    let tenant = useSelector(state=>state.auth.config.tenant);
    const {roundUpTdsAmount} = useSelector(state=>state.auth.config.plugins);
    let exclude=(tenant!=="DEZ")
    const [previousType,setPreviousType] = useState(undefined);
    const [showCustomFormId, setShowCustomFormId] = useState(false);
    const [showServiceCustomFormId, setShowServiceCustomFormId] = useState(false);
    const [openTdsDetails, setOpenTdsDetails] = useState(false);
    const [showAdditionalChargeFormId, setShowAdditionalChargeFormId] = useState(false);

	const [updateGstCredit, setUpdateGstCredit] = useState(false)
	const [edit, setEdit] = useState(undefined)
	const [bulkTds, setBulkTds] = useState(false)
	const [applyingBulkTds, setApplyingBulkTds] = useState(false)
	const [remove, setRemove] = useState(undefined)
	const [credit, setCredit] = useState(false)
	const [addItem, setAddItem] = useState(false)
	const [pastInvoices, setPastInvoices] = useState([])
    const [editAdditionalCharge,setEditAdditionalCharge] = useState();
    const [deleteAdditionalCharge,setDeleteAdditionalCharge] = useState();
    const [rcLineItemTax,setRcLineItemTax] = useState({isRCItem:false,tax:0});
    const getCredit = useRef()
    const HISTORY = useHistory();
    const [lineItemViolation,setLineItemViolation] = useState();
    const [lineItemOCRData,setLineItemOCRData] = useState();
    const [showTdsDetails, setShowTdsDetails] = useState({});
    const [showAiSuggestion, setShowAiSuggestion] = useState(undefined);
    const grnNo=props.data && props.data.grnNos && props.data.grnNos.length>0?(props.data.grnNos[0]) : props.details && props.details.grnId ? props.details.grnId : null
    const { tdsCertificates } = useVendorContactHook(props.details.vendor.id);
    const [show3WayMatchingMismatch, setShow3WayMatchingMismatch] = useState(false);


    const MISMATCH = {
        LINE_ITEM_MISMATCH_AMOUNT : "Line Item Amount Mismatch",
        LINE_ITEM_MISMATCH_PRICE : "Line Item Price Mismatch",
        LINE_ITEM_MISMATCH_QUANTITY:  "Line Item Quantity Mismatch"
    }

    let {debitNote,
        invoiceStatus,
        systemInvoiceId,
        vendorCode,
        vendorAddress,
        panNumber,
        enableAddLineItem,
        enableLineItemPlugin,panStatus,
        amountAdjustedAgainstDeposit,
        vendorDetails
    } = props.data;

    const {disableUpdate,disableRcm,status,approvalStatus} = props; 
    const {
        searchProductByService,
        multipleDepositTypePerContractItem,
        vendorAdditionalCharges,
        tdsAtLineItemAutomationV2,
        tdsAtLineItemAutomation,
        allowInvoiceAddLineItemAtDraft
    } = useSelector(state => state.auth.config.plugins)
    const compositVendor = props && props.details && props.details.vendor && props.details.vendor.compositionVendor

    // tds is editable at line item level - mirrors the condition used inside LineItemModal
    const contractId = props.data.contractId;
    const tdsAtLineItemEnabled = (props.allowTdsAtLineItem === undefined ? true : props.allowTdsAtLineItem) &&
        (((props.tdsAtLineItemAutomation || props.tdsAtLineItem) && !contractId) || (contractId && props.tdsAtLineItemInContract))
    const canEditLineItem = (approvalStatus(invoiceStatus) || (invoiceStatus === 'DRAFT' && allowInvoiceAddLineItemAtDraft)) && exclude && !disableUpdate
    const showBulkTds = tdsAtLineItemEnabled && canEditLineItem && props.data.table && props.data.table.length > 1

    useEffect(()=>{
        get(`vendor/costAllocation/getAllocations?referenceType=vendor-invoice&referenceId=${systemInvoiceId}`,(e,r)=>{
            if(r) {
                setPreviousType({
                    key:r.data.baseType,
                    value:r.data.baseType
                })
            }
        })
    },[])

    useEffect(()=>{
        if(props.data && props.data.table && props.data.table.length){
            let RCItem = false;
            let calcTax = 0;
            props.data.table.forEach(el =>{
                if(el.rcItem){
                    RCItem = true;
                    calcTax += el.tax_amt;
                }
            })
            setRcLineItemTax({isRCItem:RCItem,tax:calcTax});
        }
    },[props])


    useEffect(() => {
        if (props.data.vendorDetails && props.data.vendorDetails.id) {
            let mData = {
                filter: `${props.data.vendorDetails.id}@t0.vendor_id`
            }
            get(`vendor/invoicing/invoices`, (e, r) => {
                if (r) {
                    setPastInvoices(r.invoices)
                }
            }, mData)
        }
    }, [props.data.vendorDetails])
    
// maps the tds object returned by the tds selector onto the keys the update api expects
const mapTdsOnPayload = (payload) =>{
    if(payload && payload.tds && payload.tds.type && payload.tds.type==="master"){
        const { id, tdsSlab } = payload.tds;
        delete payload.tds;
        payload["tds_master"] = id
        if(!tdsAtLineItemAutomationV2 && !tdsAtLineItemAutomation){
            payload.tdsSlab = tdsSlab;
        }
    }
    else if(payload && payload.tds){
        const { tdsSlab, tdsCode, tdsDesc } = payload.tds;
        delete payload.tds;
        payload.tdsSlab = tdsSlab;
        payload.tdsCode = tdsCode;
        payload.tdsDesc = tdsDesc;
    }
    return payload;
}

const onSaveItem = (payload) =>{
    mapTdsOnPayload(payload);
   post(`vendor/invoicing/${systemInvoiceId}/invoiceItem.update`,
   {...payload},
   (e,r) =>{
    if(r) {
        props.onReload()
        showToast({
            type: 'success',
            message:'Line Item Updated Successfully'
        })
    } else if(e){
       handleError(e)
    }
 setEdit(false)
   })
}

// applies the same tds section on every selected line item, one update call per item
const onApplyBulkTds = (tds,itemIds) =>{
    setApplyingBulkTds(true);
    let failed = 0;

    const updateItem = (index) =>{
        if(index >= itemIds.length){
            setApplyingBulkTds(false);
            setBulkTds(false);
            props.onReload();
            if(failed){
                showToast({
                    type: 'error',
                    message:`Tds updated on ${itemIds.length-failed} of ${itemIds.length} line items, ${failed} failed`
                })
            } else {
                showToast({
                    type: 'success',
                    message:`Tds applied on ${itemIds.length} line item${itemIds.length>1?'s':''}`
                })
            }
            return;
        }
        let payload = mapTdsOnPayload({itemId:itemIds[index],tds:{...tds}});
        post(`vendor/invoicing/${systemInvoiceId}/invoiceItem.update`,payload,(e)=>{
            if(e) {
                failed = failed+1;
            }
            updateItem(index+1);
        })
    }

    updateItem(0);
}

const onAddLineItem = (payload) =>{
   post(`vendor/invoicing/${systemInvoiceId}/invoiceItem.add`,
   {data:payload},
   (e,r) =>{
    if(r) {
        props.onReload();
        post(`vendor/costAllocation/removeAllocation`,{invoiceId:systemInvoiceId},(e,r)=>{
            if(r) {
                props.onReload()
            } else {
                props.onReload()
            }
        })
        showToast({
            type: 'success',
            message:'Line Item Added Successfully'
        })
    } else if(e){
       handleError(e)
    }
    setAddItem(false)
   })
}
    const totalTaxAmount = props.additionalCharges && props.additionalCharges.length > 0
    ? props.additionalCharges.reduce((sum, charge) => sum + (charge.amount || 0), 0)
    : 0;

const reimbursementExpense = props.details && props.details.reimbursementExpense

    const formatTdsAmount = (tdsAmount) => {
        if (!tdsAmount && tdsAmount !== 0) return tdsAmount;
        if (roundUpTdsAmount) {
            return numberWithCommas(Math.ceil(tdsAmount));
        }
        return numberWithCommas(tdsAmount.toFixed(2));
    };

    const renderTable = (item, index)=>{
        return(
            <div key={`entry-${index}`} style={{display: 'flex', justifyContent: 'space-evenly', margin: '15px 0px'}}>
                <div style={{width: '160px'}}>
                    <b>{`${index+1}). `}</b>{item.desc}<br/>
                    {props.data.poNumber?`Item ref no :${item.referenceId}`:null} {props.data.poNumber?<br/>:null}
                    {item.orderId?`PO Number:${item.orderId}`:null} <br/>
                    Code: {item.hsn} <br /> 
                    Service : {item.service} <br></br>
                    {item.glCode  && item.glCode !== 'undefined' ? <>GL Code : {item.glCode} <br/></> : null}
                    {item.serviceDesc && (
                     `Desc : ${item.serviceDesc}`
                    )}
                    {item.notes ?<>Notes : {item.notes} <br></br></> :null}
                    <div style={{}}>
                  <p> {item.gstNonCreditable ? `Gst  Credit  Applicable : No`:`Gst Credit  Applicable :Yes`}</p>
                    {item.budget_id && <p>Budget Id: {item.budget_id}</p>}
                    {item.budgeted_amount && <p>Budget Amount: {item.budgeted_amount}</p>}
                    {item.budget_status && <p>Budget Status: {item.budget_status}</p>}
                    {item.reverse_budget_id && <p>Reverse Budget Id: {item.reverse_budget_id}</p>}
                    {item.reverse_budgeted_amount && <p>Reverse Budget Amount: {item.reverse_budgeted_amount}</p>}
                    {item.reverse_budget_status && <p>Reverse Budget Status: {item.reverse_budget_status}</p>}
                    {approvalStatus(invoiceStatus) && exclude && 
                    <div className="penciledit" onClick={()=>{ 
                      if(disableUpdate) return;
                      setUpdateGstCredit(item)
                      setCredit(!item.gstNonCreditable)
                    }} 
                    style={{display:'inline-block',height:10,width:10}}
                    />
                    }
                    </div>
                    {item.tds && (
                        <div>
                            <div 
                                style={{paddingTop:5, cursor: 'pointer',marginBottom:10}}
                                onClick={() => setShowTdsDetails(prev => ({
                                    ...prev,
                                    [item.id]: !prev[item.id]
                                }))}>
                                <h4>{showTdsDetails[item.id] ? 'Hide' : 'Show'} TDS Details</h4>
                            </div>
                            {showTdsDetails[item.id] && (
                                <div>
                                    tdsAmount : {item.tds.tdsAmount} <br></br>
                                    tdsCode : {item.tds.tdsCode} <br></br>
                                    tdsRate : {item.tds.tdsRate} <br></br>
                                    tds Desc : {(item.tds && item.tds.tdsDesc) || '-'} <br></br>
                                </div>
                            )}
                        </div>
                    )}
                    {
                        item.attrs && Object.keys(item.attrs).length > 0 &&
                            item.attrs["lineItemReferenceNo"] ?
                            <p>Line Item Reference No : {item.attrs["lineItemReferenceNo"]}</p> : <></>
                    }
                    {
                        item.attrs && Object.keys(item.attrs).length > 0 &&
                            item.attrs["SO Number"] ?
                            <p>SO No : {item.attrs["SO Number"]}</p> : <></>
                    }
                    {
                        item.attrs && Object.keys(item.attrs).length > 0 &&
                            item.attrs["seven-segment"] ?
                            <p>Seven-segment : {item.attrs["seven-segment"]}</p> : <></>
                    }
                    {
                        item.attrs && Object.keys(item.attrs).length > 0 &&
                        item.attrs["tds_automation"] ?
                            <p>TDS Automation : {item.attrs["tds_automation"]}</p> : <></>
                    }
                    {item.forms && item.forms.length > 0 ? (
                    <div>
                        <div 
                            style={{paddingTop:5,cursor: 'pointer'}}
                            onClick={() => setShowCustomFormId(showCustomFormId && showCustomFormId === item.id ? false : item.id)}>
                            <h4>
                            {showCustomFormId === item.id ? 'Hide': 'Show'} Custom form</h4>
                        </div> <br />
                        {showCustomFormId === item.id &&
                            sortAndMapForms(item.forms).map((e) => (
                                <div style={{ flexDirection: 'column' }} key={e.key}>
                                    <p style={{fontWeight:250,color:'grey'}}> {e.displayKey}: <span style={{fontWeight:500,color:'black'}}>{e.value}</span></p>
                                    <br />
                                </div>
                            ))
                        }
                    </div>
                    ) : null}
                    {
                        (item && item.poInvoiceMismatchReason && ["dtc","DTDC12"].includes(tenant)) ?<div
                            className='ml1'
                            style={{ textAlign: 'center', cursor: 'pointer', color: 'red', fontWeight: '500', fontSize: '11px', border: '1px solid red', borderRadius: '4px', padding: '3px 4px', marginTop: '3px' }}
                            onClick={() => {
                                setShow3WayMatchingMismatch(item.poInvoiceMismatchReason)
                            }}>
                            View 3 way matching mismatch
                        </div> : <></>
                    }
                    {item.serviceAttrs && _.size(item.serviceAttrs) > 0 ? (
                            <div>
                                <div className='mt2'
                                    style={{ fontSize: 13, fontWeight: '700', cursor: 'pointer' }}
                                    onClick={() => setShowServiceCustomFormId(showServiceCustomFormId && showServiceCustomFormId === item.id ? false : item.id)}>
                                    <p> {showServiceCustomFormId === item.id ? 'Hide' : "Show Service Tags"}</p>
                                </div>
                                <br />
                                {showServiceCustomFormId === item.id &&
                                    _.keys(item.serviceAttrs).map((e) => (
                                        <div style={{ flexDirection: 'column', marginTop: -10, textAlign: 'left' }} key={e}>
                                            <p style={{ fontWeight: 250, color: 'grey' }}> {e}: <span style={{ fontWeight: 500, color: 'black' }}>{item.serviceAttrs[e]}</span></p>
                                            <br />
                                        </div>
                                    ))}
                            </div>
                        ) : null}
                    {
                        item.violations && !!item.violations.length &&
                        <p onClick={() => setLineItemViolation(item.violations)} style={{ color: 'var(--primary-color)', cursor: 'pointer' }}><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Show Violation </p>
                    }
                    {
                        item.ocrData &&
                        <p onClick={()=>setLineItemOCRData(JSON.parse(item.ocrData))} style={{ color: 'var(--primary-color)', cursor: 'pointer', marginTop:3 }}><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Show OCR Data </p>
                    }
                    </div>
               
                {
                    props.data.costAllocationDone || (props.data.enableCostAllocation && approvalStatus(props.data.status)) ?
                    <div style={{width:100,display:'flex'}}>
                         <div style={{
                             backgroundColor: "var(--green-color)",
                             color: "#fff",
                             height: 20,
                             width: 20,
                             borderRadius: "50%",
                             fontWeight: "bold",
                             cursor: "pointer",
                             fontSize: 16,
                             display: "flex",
                             alignItems: "center",
                             justifyContent: "center",
                             marginRight:5
                             }} onClick={()=>{
                                setOpen(index+1)
                            }}>
                             +
                         </div>
                        
                        {
                            item.isAllocationAvailable ?
                            <div onClick={()=>{
                                setOpen(index+1)
                            }} style={{cursor:'pointer',color:'var(--primary-color)',marginLeft:5}}>View</div>:<div>-</div>
                        }
                    </div>
                    :null

                }
                <div style={{width: '100px',}}> {item.price ?numberWithCommas(item.price.toFixed(2)):item.price}</div>
                <div style={{width: '100px',}}> {item.qtty}</div>
                {debitNote?<div style={{width: '100px',}}> {item.debitQty}</div>:null}
                <div style={{width: '100px',}}> {item.base_amt ?numberWithCommas(item.base_amt.toFixed(2)):item.base_amt}</div>
                {!props.data.singleLine && !props.data.poNumber && <div style={{width: '100px',}}> {item.taxSlab}%</div>}
                <div style={{width: '100px'}}> {item.tax_amt ?numberWithCommas(item.tax_amt.toFixed(2)):numberWithCommas(item.tax_amt)}</div>
                {(tenant==="TESTHDL" || tenant==="KARANDEVENV" || tenant==="INDIAN"||tenant === 'ANRCK')?<div style={{width: '100px',}}>{(item && item.tds && item.tds.tdsCode)?item.tds.tdsCode:'-'}</div>:null}
                {(tenant==="TESTHDL" || tenant==="KARANDEVENV" || tenant==="INDIAN"||tenant === 'ANRCK')?<div style={{width: '100px',}}>{(item && item.tds && item.tds.tdsRate)?`${item.tds.tdsRate}%`:0}</div>:null}
                {(tenant==="TESTHDL" || tenant==="KARANDEVENV" || tenant==="INDIAN"||tenant === 'ANRCK')?
               <div>
               <div style={{width: '100px', display:'flex'}}>
                    <div>{(item && item.tds && item.tds.tdsAmount)?item.tds.tdsAmount:0}</div>
                    <div onClick={()=>setOpenTdsDetails(item)} style={{cursor:'pointer', border:'2px solid black', borderRadius:'50%', marginLeft:'30px',height:15,width:15, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold'}}>i</div>
                </div>
                {/* AI Suggestions */}
                 <DiceAiButton onClick={()=> {setShowAiSuggestion(item)}} itemId={item.id} />
               </div>
            :null}
                <div style={{width: '100px', textAlign: 'right'}}> {item.amount ?numberWithCommas(item.amount.toFixed(2)):numberWithCommas(item.amount)} </div>
                {props.budgetingV2? <div style={{ width: '100px', textAlign: 'right',display:'flex',justifyContent:'center' }}>
                    <div style={{
                        width: 45
                    }}>
                        <div style={{ width: 44 }}>
                            <div onClick={() => {
                                if(item.orderId || disableUpdate) return;
                                post(`vendor/invoicing/${systemInvoiceId}/invoicing.change`,{itemId:item.id,key:"autoBudgeting",value:(item.autoBudgeting === "yes") ? 'no' : 'yes'},(e,r)=>{
                                    if(r){
                                        showToast({
                                            type: 'success',
                                            message:'Line Item updated Successfully'
                                        })
                                        props.onReload();
                                    }else{
                                        handleError(e);
                                    }
                                })
                            }} className="portlet-switch">
                                <div className={`check ${(item.autoBudgeting === "yes") ? 'on' : 'off'}`} />
                            </div>
                        </div>
                    </div>
                </div>:null}
                {item.cessAmount?(
                    <div style={{width: '100px',textAlign:'center'}}> {item.cessAmount ?numberWithCommas(item.cessAmount.toFixed(2)):item.cessAmount}</div>
                ):null}
              
              <ReadOnly 
                type={(invoiceStatus === 'TAXATION_APPROVAL')?"Taxation Stage":undefined}>
               <div style={{width: '100px', textAlign: 'right', display:'flex', flexDirection:'column'}}>
               {(approvalStatus(invoiceStatus) || (invoiceStatus === 'DRAFT' && allowInvoiceAddLineItemAtDraft)) && exclude && 
                <span  style={{padding:5,color:'var(--primary-color)',cursor:'pointer'}}
                   onClick={() => setEdit(item)}>
                    EDIT
                </span>}
               {((approvalStatus(invoiceStatus) || (invoiceStatus === 'DRAFT' && allowInvoiceAddLineItemAtDraft))  && enableLineItemPlugin && !disableUpdate)&&
                <span  style={{padding:5,color:'var(--red-color)',cursor:'pointer',}}
                onClick={() => setRemove(item)}>
                    Remove
                </span>}
                </div>
              </ReadOnly>
            </div>
        )
    }

    let partial = 0;
    props.data.allSettlement.forEach(val=>{
        if(val.transferred) {
            partial = partial+val.amount
        }
    })

    let paidAmount=0;
    let partialTDS=0;
    props.data.allSettlement.forEach(val=>{
        if(val.transferred) {
            paidAmount = paidAmount+val.amount
            partialTDS = partialTDS+val.tdsAmount
        }
    })

    let totalPayable = +props.data.payable_amt||0;
    let bill_to_gstin = props.data.bill_to_gstin || undefined;
    let totalFinalPayable = 0;
    // this not required as per handled COMPLETED status
    // if(props.data.mSettlement.amount) {
    //      totalFinalPayable = (props.data.mSettlement.paidAmount-(props.data.mSettlement.partial-props.data.mSettlement.partialTds)).toFixed(2)
    // }
     // additional charges included in total amount
    let totalAdditionalCharge = Number(props.data.totalAdditionalCharge) || 0;
    let baseAdditionalCharge = Number(props.data.baseAdditionalCharge) || 0;
    let grossAdditionalCharge = Number(props.data.grossAdditionalCharge) || 0;
    let additionalChargesTds = Number(props.data.additionalChargesTds) || 0;
    let totalChargesCombine = totalAdditionalCharge+ baseAdditionalCharge+grossAdditionalCharge-additionalChargesTds;

    if(props.data.isCreditNote || props.data.isDebitNote){
        let credit = +props.data.creditNoteTotal||0 
        let debit = +props.data.debitNoteTotal ||0

        totalPayable =  totalPayable  - credit + debit;
    } 

    if(props.data.creditNoteTds) {
        totalPayable += props.data.creditNoteTds;
        totalFinalPayable = Number(totalFinalPayable)+props.data.creditNoteTds
    }

    if(props.data && ['SETTLEMENT_REQUEST','APPROVAL','TAXATION_APPROVAL','VPT_HOLD','PARTIAL_PAYMENT','COMPLETED'].includes(props.data.status)) {
        totalFinalPayable  =  totalPayable - (paidAmount-partialTDS)
    }


    const [costAllocationForm, setCostAllocationForm] = useState([]);

    const getCostAllocationForm = () => {
        return new Promise((resolve, reject) => {
            get(`forms/invoice::item::costAllocation::${props.data.categoryId}`,(e,r)=>{
                if(r) {
                    setCostAllocationForm(r.forms);
                    resolve(r.forms);
                } else {
                    reject(e);
                }
            })
        })
    }

    
 return(
        <div className='FadeRight-Effect' style={{width: '100%', fontSize: '12px'}}>
        <div style={{textAlign: 'center', fontSize: '22px', fontWeight: 'bold'}}>INVOICE</div>
            {
              
                props.data.discount?
                    <p style={{
                        top:10,
                        left:0,
                        padding:'12px 30px',
                        position:'absolute',
                        background:"green",
                        color:'var(--white-color)',
                        fontSize:11
                    }}>
                        Discounted at {numberWithCommas(props.data.discount)} %
                    </p>:undefined
            }
            {
              
              (tdsCertificates && tdsCertificates.length>0) || reimbursementExpense ||  props.data.rcInvoice || rcLineItemTax.isRCItem ||( props.data.vendorDetails.msmeId && props.data.vendorDetails.msmeId!=='NA') || props.data.vendorDetails.eInvoiceApplicable || (props.details && props.details.invoice && props.details.invoice.isAmended) ?
                  <p style={{
                      top:85,
                      left:0,
                      padding:'12px 30px',
                      position:'absolute',
                      background:'var(--primary-color)',
                      color:'var(--white-color)',
                      fontSize:11
                  }}>
                    {[
                       tdsCertificates && tdsCertificates.length>0 ? 'LDC Vendor' : null,
                       (props.data.vendorDetails && props.data.vendorDetails.msmeId && props.data.vendorDetails.msmeId  !== 'NA') ? 'MSME VENDOR INVOICE' : null,
                       (props.data.rcVendor ||  props.data.rcInvoice || rcLineItemTax.isRCItem) ? 'RCM INVOICE' : null,
                       props.data.vendorDetails.eInvoiceApplicable ? 'E-Invoice' : null,
                       reimbursementExpense ? 'Mixed Entry Invoice' : null,
                       (props.details && props.details.invoice && props.details.invoice.isAmended) ? 'Amended' : null
                    ].filter(Boolean).join(' / ')}
                  </p>:undefined
             }
          {  
               props.data.digitallySigned && (
                  <p style={{
                    position: 'absolute',
                    top: 85,
                    right: 20,
                    padding: '12px 30px',
                    background:'#f0fdf4',
                    color: '#15803d',
                    fontSize: 11,
                    borderRadius: '4px',
                    fontWeight: 'bold'
                  }}>
                  <span role="img" aria-label='check' >✅</span> Digitally Signed
                  </p>
                )
        }
         {  
               props.adjustedInvoice && (
                  <p style={{
                    top:13,
                    left:0,
                    padding:'12px 30px',
                    position:'absolute',
                    background:'var(--primary-color)',
                    color:'var(--white-color)',
                    fontSize:11
                  }}>
                   Adjustable Invoice
                  </p>
                )
        }
        <div style={{position: 'relative', border: '1px solid var(--border-color)', padding: '20px', borderRadius: '15px', marginTop: '30px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>
                    <b>Vendor</b><br/>
                    {props.data.vendor}<br/>
                    Vendor Code: {vendorCode} <br></br>
                    Email: {props.data.email}<br/>
                    GSTIN: {props.data.vendor_id || 'NA'} <br />
                    PAN: {panNumber || 'NA'} <br />
                    panStatus: {panStatus || 'NA'} <br />
                    {props.data.vendorDetails?props.data.vendorDetails.gstinStatus?<>GSTIN STATUS : {props.data.vendorDetails.gstinStatus} <br /></>:null:null}
                    {props.data.vendorDetails?props.data.vendorDetails.taxPayerType?<>Tax Payer Type : {props.data.vendorDetails.taxPayerType} <br /></>:null:null}
                    {
                        (vendorDetails && vendorDetails.bank && Object.keys(vendorDetails.bank).length) ?
                            Object.keys(vendorDetails.bank).filter((key)=>key==='account' || key==='bankName' || key==='branchName' || key==='ifsc' || key==='name').map((key)=>{
                                return(
                                    <div>
                                        {key} : {vendorDetails.bank[key]}
                                    </div>
                                )
                            }):null
                    }
                      MSME / Udyam  Number : {props.data.vendorDetails ?props.data.vendorDetails.msmeId || 'NA':'NA'} <br />
                     Address: {vendorAddress && vendorAddress.address} <br></br>
                     Composit Vendor: {compositVendor?'Yes':'No'} <br></br>
                    { vendorAddress && vendorAddress.state} {vendorAddress && vendorAddress.pincode} <br></br>
                     {props.details.vendor && props.details.vendor.poc && props.details.vendor.poc.length > 0 && (
                         <div>
                             <div>POC Name: {props.details.vendor.poc[0].name}</div>
                             <div>POC Email: {props.details.vendor.poc[0].email}</div>
                         </div>
                     )}
                </div>
                <div style={{textAlign: 'right'}}>
                 Date: {props.data.date}<br/>
                {props.data.due?<>Due Date: {moment(props.data.due).format('DD-MM-YYYY')} <br/></>:<></>}
                Invoice Number: {props.data.Invoice_id}<br/>
                     {props.data.poNumber ? <p style={{ cursor: 'pointer' }} onClick={() => HISTORY.push(`/app/vendor/procurement/order/${props.data.poId}/details`)}>PO Number: {props.data.poNumber}</p> : ''}<br />
                     {props.data && props.data.multiPo && props.data.multiPo.length > 0 ? <>
                         PO Number
                         {props.data.multiPo.map((e) => <p style={{ cursor: 'pointer' }} onClick={() => HISTORY.push(`/app/vendor/procurement/order/${e.id}/details`)}>{e.poId}</p>)}<br />
                     </>
                    : null}
                {grnNo ? `GRN No : ${grnNo}`: ''}<br/>
                {props.data.asn ? `ASN: ${props.data.asn.asnId}`: ''}<br/>
                {props.data.asn ? `ASN Created On: ${moment(props.data.asn.createdAt).format('DD-MM-YYYY')}`: ''}<br/>
                {props.data.grnNos && props.data.grnNos.length ? `GRN: ${props.data.grnNos.join(",\n")}`: ''}<br/>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>
                <div style={{paddingRight: '20px'}}>
                    <b>Billing Address</b><br/>
                    {props.data.bill_to.title?<span>{props.data.bill_to.title}<br></br></span>:null}
                    {props.data.bill_to.registeredName?<span>{props.data.bill_to.registeredName}<br></br></span>:null}
                    {props.data.bill_add}<br/>
                    GSTIN: {props.data.bill_to.gstin || 'NA'} <br />

                </div>
                <div style={{textAlign: 'right', paddingLeft: '20px'}}>
                    <b>{props.data.ship_to.shipTo === "yes" ? "Place of Supply":"Shipping Address"}</b><br/>
                    {props.data.ship_to.title?<span>{props.data.ship_to.title}<br></br></span>:null}
                    {props.data.ship_to.registeredName?<span>{props.data.ship_to.registeredName}<br></br></span>:null}
                    {props.data.ship_add}<br></br>
                    {props.data.ship_to.gstin?<span>{props.data.ship_to.gstin}<br></br></span>:null}


                </div>
            </div>
        </div>

        <div style={{display: 'flex', justifyContent: 'space-evenly', marginTop: '30px', fontWeight: 'bold', paddingBottom: '10px', borderBottom: '1px solid var(--border-color)'}}>
            <div style={{width: '160px'}}>Desciption</div>
            {
                props.data.enableCostAllocation && approvalStatus(props.data.status) ?
                <div style={{width:100}}>
                    Allocation
                </div>
                :null
            }
            {
                props.data.costAllocationDone ?
                <div style={{width:'100px'}}>
                    Allocation
                </div>
                :null
            }
            <div style={{width: '100px',}}>Price/Unit</div>
            <div style={{width: '100px',}}>Qty</div>
            {debitNote?<div style={{width: '100px',}}>Debit Qty</div>:null}
            <div style={{width: '100px',}}>Base Amt</div>
            {!props.data.singleLine && !props.data.poNumber && <div style={{width: '100px',}}>Tax%</div>}
            <div style={{width: '100px'}}>Tax Amt</div>
            {(tenant==="TESTHDL" || tenant==="KARANDEVENV" || tenant==="INDIAN")?<div style={{width: '100px',}}>Tds Section</div>:null}
            {(tenant==="TESTHDL" || tenant==="KARANDEVENV" || tenant==="INDIAN")?<div style={{width: '100px',}}>Tds %</div>:null}
            {(tenant==="TESTHDL" || tenant==="KARANDEVENV" || tenant==="INDIAN")?<div style={{width: '100px',}}>Tds Amount</div>:null}
            <div style={{width: '100px', textAlign: 'right'}}>Amount (INR)</div>
            {props.budgetingV2 && <div style={{width: '100px', textAlign: 'right'}}>Auto Budgeting</div>}
            {props.data && props.data.table && props.data.table.some(e => e.cessAmount) &&<div style={{width: '100px', textAlign: 'center',}}>Cess Amount</div>}
            <div style={{width: '100px', textAlign: 'right'}}>Actions</div>
            
        </div>
         {
         props.data.table.map(renderTable)
         }
      {showBulkTds ?
       <p
              style={{
                marginTop: 12,
                color: "var(--primary-color)",
                fontSize: 13,
                cursor: "pointer",
                fontWeight: 600,
                marginLeft:1
              }}
              onClick={() => {
                setBulkTds(true);
              }}
            >
              + Apply Tds To All Line Items
          </p>
          : null
          }
      {enableAddLineItem  && (approvalStatus(status) || (status === 'DRAFT' && allowInvoiceAddLineItemAtDraft)) && exclude  ?
       <p
              style={{
                marginTop: 12,
                color: "var(--primary-color)",
                fontSize: 13,
                cursor: "pointer",
                fontWeight: 600,
                marginLeft:1
              }}
              onClick={() => {
                setAddItem(true);
              }}
            >
              + Add Line Item
          </p>
          : null
          }
         {props.additionalCharges && props.additionalCharges.length > 0 &&
             <div>
                <div  style={{marginLeft:1,fontWeight:'bold',marginTop:20,}}>Additional Charges</div>
                 {
                     props.additionalCharges.map(((item, index) => {
                         return (
                             <div key={index.toString()} style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '30px', paddingBottom: '10px', borderBottom: '1px solid var(--border-color)' }}>
                                 <div style={{ width: '160px' }}>
                                   <strong>{item.type||'-'}</strong> <br/>
                                     Title : {item.title || '-'} <br />
                                     Description: {item.description}<br />
                                     taxSlab : {item.taxAmount && item.base? ((item.taxAmount / item.base) * 100): "-"}<br/>
                                     TDS Slab : {item.tdsRate||"-"}<br/>
                                     {item.forms && item.forms.length > 0 && (
                                         <div>
                                             <div
                                                 style={{ paddingTop: 5, cursor: 'pointer' }}
                                                 onClick={() => setShowAdditionalChargeFormId(showAdditionalChargeFormId === item.id ? false : item.id)}>
                                                 <h4>{showAdditionalChargeFormId === item.id ? 'Hide' : 'Show'} Custom form</h4>
                                             </div>
                                             {showAdditionalChargeFormId === item.id && item.forms.map((f, fi) => (
                                                 f.value ? <span key={fi}>{f.key}: {f.value}<br/></span> : null
                                             ))}
                                         </div>
                                     )}
                                 </div>
                                 <div style={{ width: '100px', }}>{'-'}</div>
                                 <div style={{ width: '100px', }}>{'-'}</div>
                                 <div style={{ width: '100px', }}>{item.base ? item.base.toFixed(2): '0'}</div>
                                 <div style={{ width: '100px' }}>{item.taxAmount && item.base? ((item.taxAmount / item.base) * 100) + "%": "-"}</div>
                                 <div style={{ width: '100px', }}>{item.taxAmount ? item.taxAmount.toFixed(2):"-"}</div>
                                 <div style={{ width: '100px', textAlign: 'right' }}>{item.amount? item.amount.toFixed(2):"0"}</div>
                                 <div style={{ width: '100px', textAlign: 'right' }}>
                                     {approvalStatus(invoiceStatus) &&
                                        <div className='flex' style={{flexDirection:'column',gap:5}}>
                                            <span style={{ padding: 5, color: 'var(--primary-color)', cursor: 'pointer' }}
                                             onClick={() => setEditAdditionalCharge(item)}>
                                             EDIT
                                         </span>
                                         <span style={{ padding: 5, color: 'var(--red-color)', cursor: 'pointer' }}
                                             onClick={() => setDeleteAdditionalCharge(item)}>
                                             Delete
                                         </span>
                                        </div>
                                    }
                                 </div>
                             </div>
                         )
                     }))

                 }
             </div>
         }
         {vendorAdditionalCharges && approvalStatus(invoiceStatus) && <AdditionalCharges invoiceId={systemInvoiceId} categoryId={props.data.categoryId} onReload={props.onReload}/>}
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Base Amt: </div>
                <div> {numberWithCommas(props.data.total_base.toFixed(2))}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>SGST / UTGST: </div>
                <div> {(props && props.data && props.data.sgst)?numberWithCommas(props.data.sgst.toFixed(2)):0}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>CGST: </div>
                <div> {(props && props.data && props.data.cgst)?numberWithCommas(props.data.cgst.toFixed(2)):0}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>IGST: </div>
                <div>{(props && props.data && props.data.igst)?numberWithCommas(props.data.igst.toFixed(2)):0}</div>
            </div>
        </div>

       
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Tax Amt: </div>
                <div> {(props && props.data && props.data.total_tax)?numberWithCommas(props.data.total_tax.toFixed(2)):0}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Total Tax Percentage : </div>
                <div> {Number((props.data.total_tax / props.data.total_base) * 100).toFixed(2)}%</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Cess Amount: </div>
                <div> {props.data.cessAmount?numberWithCommas(props.data.cessAmount):0}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Discount Amount: </div>
                <div> {props.data.discountAmount?numberWithCommas(props.data.discountAmount.toFixed(2)): numberWithCommas(props.data.discountAmount)}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Round Off: </div>
                <div> {props.data.roundOff?props.data.roundOff: props.data.roundOff}</div>
            </div>
        </div>
        {props.additionalCharges && props.additionalCharges.length > 0 && 
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Total additional charge: </div>
                {/* <div>{numberWithCommas(totalChargesCombine+additionalChargesTds)} </div> */}
                <div>{totalTaxAmount}</div>
            </div>
        </div>
        }
        <div className='invoice-taxes'>
            <div className='wrap' style={{fontWeight: 'bold'}}>
                <div>Total Amt: </div>
                <div> {numberWithCommas(props.data.total_amt.toFixed(2))}</div>
            </div>
        </div>
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Total TDS: </div>
                <div> {props.data.tds?  formatTdsAmount(props.data.tds)  : numberWithCommas(props.data.tds)}</div>
            </div>
        </div>
        {multipleDepositTypePerContractItem && (amountAdjustedAgainstDeposit && amountAdjustedAgainstDeposit>0) ? 
        (
             <div className='invoice-taxes'>
             <div className='wrap'>
                 <div>Adjusted Deposit: </div>
                 <div>{amountAdjustedAgainstDeposit}</div>
             </div>
         </div>
        ):null}
        {
            props.data.creditNoteTds ?
            <>
            <div className='invoice-taxes'>
                <div className='wrap'>
                    <div>Credit Note TDS: </div>
                    <div> {props.data.creditNoteTds?numberWithCommas(props.data.creditNoteTds.toFixed(2)): numberWithCommas(props.data.creditNoteTds)}</div>
                </div>
            </div>
            <div className='invoice-taxes'>
                <div className='wrap'>
                    <div> TDS Applicable: </div>
                    <div> {props.data.creditNoteTds?numberWithCommas(props.data.tds-props.data.creditNoteTds): numberWithCommas(props.data.tds-props.data.creditNoteTds)}</div>
                </div>
            </div>
            </>
            :null
        }
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>TCS: </div>
                <div> {props.data.tcs?numberWithCommas(props.data.tcs.toFixed(2)): 0}</div>
            </div>
        </div>
        {props.additionalCharges && props.additionalCharges.length > 0 && 
        <div className='invoice-taxes'>
            <div className='wrap'>
                <div>Total additional charge TDS: </div>
                <div>{numberWithCommas(additionalChargesTds)} </div>
            </div>
        </div>
        }
        {props.data.isCreditNote ?
            <>
            <div className='invoice-taxes'>
                <div className='wrap'>
                    <div>CreditNote :</div>
                    <div> {props.data.creditNoteTotal?numberWithCommas(props.data.creditNoteTotal.toFixed(2)): numberWithCommas(props.data.creditNoteTotal)}</div>
                </div>
            </div>
        </>:null}
        {props.data.isDebitNote ?
            <>
            <div className='invoice-taxes'>
                <div className='wrap'>
                    <div>DebitNote :</div>
                    <div> {props.data.isDebitNote?numberWithCommas(props.data.debitNoteTotal.toFixed(2)): numberWithCommas(props.data.creditNoteTotal)}</div>
                </div>
            </div>
        </>:null}
        <div style={{display: 'flex', padding: '10px 0px', fontWeight: 'bold', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)'}}>
            <div style={{flexGrow: 1}}>Total Vendor Payable Amount: </div>
            <div style={{width: '100px', textAlign: 'right'}}>{numberWithCommas(totalPayable+totalChargesCombine-amountAdjustedAgainstDeposit)}</div>
        </div>
        {
             props.data.rcInvoice && !props.data.mSettlement.amount ?
             <>
                 <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Reverse. Charges: </div>
                        <div>{(props && props.data && props.data.total_tax)?numberWithCommas(props.data.total_tax.toFixed(2)):0}</div>
                    </div>
                </div>
                <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Total Payable Amount : </div>
                        <div> {numberWithCommas(totalPayable.toFixed(2)- ((props && props.data && props.data.total_tax)?props.data.total_tax.toFixed(2):0) + totalChargesCombine)}</div>
                    </div>
                </div>
                
             </>
             : (rcLineItemTax.isRCItem && !props.data.mSettlement.amount) ?
             <>
                 <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Reverse. Charges: </div>
                        <div> {numberWithCommas(rcLineItemTax.tax.toFixed(2))}</div>
                    </div>
                </div>
                <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Total Payable Amount : </div>
                        <div> {numberWithCommas(props.data.payable_amt.toFixed(2)- rcLineItemTax.tax.toFixed(2)+ totalChargesCombine)}</div>
                    </div>
                </div>
                
             </>:null
        }
        {/* this not required as per handled COMPLETED status */}
        {/* {
            props.data.mSettlement.amount ?
            <>
                
                <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Reverse. Charges: </div>
                        <div> {numberWithCommas(props.data.mSettlement.reverseCharge.toFixed(2))}</div>
                    </div>
                </div>
                <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Partial Payment: </div>
                        <div> {numberWithCommas(props.data.mSettlement.partial.toFixed(2))}</div>
                    </div>
                </div>
                <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Partial Advance Tds: </div>
                        <div> {numberWithCommas(props.data.mSettlement.partialTds.toFixed(2))}</div>
                    </div>
                </div>
                

                <div style={{display: 'flex', padding: '10px 0px', fontWeight: 'bold', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)'}}>
                    <div style={{flexGrow: 1}}>Total Payable Amount: </div>
                    <div style={{width: '100px', textAlign: 'right'}}> {numberWithCommas(Number(totalFinalPayable))}</div>
                </div>  
               
            </>
            :null
        } */}
        { (['SETTLEMENT_REQUEST','APPROVAL','TAXATION_APPROVAL','VPT_HOLD','PARTIAL_PAYMENT','COMPLETED'].includes(props.data.status)) && (
            <>
                {props.data.mSettlement && props.data.mSettlement.reverseCharge?
                   <div className='invoice-taxes'>
                      <div className='wrap'>
                        <div>Reverse. Charges: </div>
                        <div> {numberWithCommas(props.data.mSettlement.reverseCharge.toFixed(2))}</div>
                     </div>
                  </div>:null
               }
                <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Partial Payment: </div>
                        <div> {numberWithCommas(paidAmount.toFixed(2))}</div>
                    </div>
                </div>
                <div className='invoice-taxes'>
                     <div className='wrap'>
                        <div>Partial Advance Tds: </div>
                        <div> {numberWithCommas(partialTDS.toFixed(2))}</div>
                    </div>
                </div>
                <div style={{display: 'flex', padding: '10px 0px', fontWeight: 'bold', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)'}}>
                    <div style={{flexGrow: 1}}>Total Payable Amount: </div>
                    <div style={{width: '100px', textAlign: 'right'}}> 
                         {numberWithCommas(
                             Number(totalFinalPayable) + Number(totalChargesCombine) -
                             Number(
                                 (props.data && props.data.mSettlement && props.data.mSettlement.reverseCharge)
                                     ? props.data.mSettlement.reverseCharge
                                     : (rcLineItemTax && rcLineItemTax.isRCItem && rcLineItemTax.tax)
                                         ? Number(rcLineItemTax.tax)
                                         : props.data.rcInvoice && !props.data.mSettlement.amount && props.data.total_tax
                                             ? Number(props.data.total_tax)
                                             : 0
                             )
                         )}
                    </div>
                </div>  
                <div className='invoice-taxes'>
               {(props && props.data && props.data.currencyExchangeRate) && 
                <div className='wrap invoice-summary'>
                    <div className='flex-1'>Base Currency Amt:</div>
                    <div className='flex-1'> {props.data.bill_add_full?props.data.bill_add_full.currency:""} {props.data.baseCurrencyAmount ? numberWithCommas(props.data.baseCurrencyAmount):props.data.baseCurrencyAmount}</div>
                </div>
               }
            </div>
                {(props && props.data && props.data.currencyExchangeRate)?
                <div className='invoice-taxes'>
                <div className='wrap invoice-summary'>
                    <div className='flex-1'>Currency Exchange Rate:</div>
                    <div className='flex-1'>{props.data.currencyExchangeRate}</div>
                </div>
            </div>:null}
            </>
        )}
        <div>
            <p style={{fontWeight:500,fontSize:16,marginTop:15,marginBottom:10}} >Past Invoices</p>
            <div style={{marginBottom: 0}}>
					<PastInvoices invoices={pastInvoices}/>
				</div>
        </div>
        <div style={{height: '40px'}}/>


        {open && previousType && (props.data.costAllocationDone ? true: !props.onlyLineItemCostAllocationAllowed) ?
		<LineItemCostAllocation
            disabled={disableUpdate}
			lineItems={[...props.data.table]}
			index={open}
            gstin={bill_to_gstin}
			view={approvalStatus(invoiceStatus)?false:true}
            edit={approvalStatus(invoiceStatus)}
            previousType={previousType}
            invoiceTotalAmount={props.data.total_amt}
			close={()=>{
				setOpen(false);
			}}
            categoryId={props.data.categoryId}

            init={async (data)=>{

                let lineItemObject = {};
                props.data.table.filter((_,index)=>(index!==open-1)).forEach(i=>{
                    lineItemObject[i.id] = i.costAllocations
                })

                data.costAllocation.costAllocationAtItems = {
                    ...data.costAllocation.costAllocationAtItems,
                    ...lineItemObject
                }

                const processCostAllocationItems = async (costAllocationAtItems) => {
                    // Get forms if not already loaded
                    let forms = costAllocationForm;
                    if (!forms || forms.length === 0) {
                        try {
                            forms = await getCostAllocationForm();
                        } catch (e) {
                            console.error("Error fetching cost allocation forms:", e);
                            return costAllocationAtItems;
                        }
                    }
                    const findFormByFieldId = (fieldId) => {
                        return forms.find(form => {
                            if (!form.name) return false;
                            return String(form.name) === String(fieldId) || Number(form.name) === Number(fieldId);
                        });
                    };

                    // Process each allocation item
                    const processedItems = {};
                    Object.keys(costAllocationAtItems).forEach(key => {
                        const allocations = costAllocationAtItems[key];
                        if (!Array.isArray(allocations)) {
                            processedItems[key] = allocations;
                            return;
                        }
                        processedItems[key] = allocations.map(item => {
                            if (item.customForms && !item.formData) {
                                const transformedCustomForms = {};
                                Object.keys(item.customForms).forEach(fieldIdKey => {
                                    const matchedForm = findFormByFieldId(fieldIdKey);
                                    if (matchedForm && matchedForm.id) {
                                        transformedCustomForms[matchedForm.id] = item.customForms[fieldIdKey];
                                    } else {
                                        transformedCustomForms[fieldIdKey] = item.customForms[fieldIdKey];
                                    }
                                });
                                return {
                                    ...item,
                                    customForms: transformedCustomForms
                                };
                            }
                            return item;
                        });
                    });

                    return processedItems;
                };
                
                // Process the costAllocationAtItems
                data.costAllocation.costAllocationAtItems = await processCostAllocationItems(data.costAllocation.costAllocationAtItems);

                post(`vendor/invoicing/${systemInvoiceId}/invoicing.costAllocation.update`,data,(e,r)=>{
                    if(r) {
                        showToast({
                            type:'success',
                            message:'Cost Allocation Update Successfully'
                        })
                        setOpen(false);
                        props.init();
                    } else {
                        showToast({
                            type:'error',
                            message:e.data.message
                        })
                    }
                })
            }}
		/>
		:null
	  }
      {/* For all clients */}
    {
		open && !previousType  && !props.onlyLineItemCostAllocationAllowed ?
		<LineItemCostAllocation
            disabled={disableUpdate}
			lineItems={[...props.data.table]}
			index={open}
			view={false}
            edit={false}
            categoryId={props.data.categoryId}
            gstin={bill_to_gstin}
            previousType={previousType && previousType.value ? previousType : undefined}
            invoiceTotalAmount={props.data.total_amt}
			close={()=>{
				setOpen(false);
			}}
            updateLineItems={(items, type) => {
                setPreviousType(type);
                props.updateAllocation(items,type,open-1);
              }}

		/>
		:null
	  }
      {/* specific for Anarock */}
      {
		open && (props.onlyLineItemCostAllocationAllowed && !props.data.costAllocationDone)?
		<LineItemCostAllocation
            disabled={disableUpdate}
			lineItems={[...props.data.table]}
			index={open}
			view={false}
            allowOnlyLineItem={true}
            edit={false}
            categoryId={props.data.categoryId}
            gstin={bill_to_gstin}
            previousType={previousType && previousType.value ? previousType : undefined}
            invoiceTotalAmount={props.data.total_amt}
			close={()=>{
				setOpen(false);
			}}
            updateLineItems={(items, type) => {
                setPreviousType(type);
                props.updateAllocation(items,type,open-1);
              }}

		/>
		:null
	  }
          {
		  	updateGstCredit ?
						<Modal 
							buttonName="Apply"
							onSave={()=>{
                                post(`/vendor/invoicing/${systemInvoiceId}/details.change`, {
                                    'key':'gst_creditable', 'value':`${!credit}`,itemId:updateGstCredit.id}, (e, r) => {
                                    if (r) {
                                        props.onReload()
                                        showToast({
                                            type: 'success',
                                            message: 'Invoice Updated'
                                        })
                                    } else if (e) {
                                        handleError(e);
                                    }
                                    setUpdateGstCredit(null)
                                });

							}} 
							title={"Update GST Credit"}
							des="Please update Gst credit value" 
							close={() => {
								setUpdateGstCredit(null)
							}} 
							style={{
								save: {
									width: '100%',
									textAlign: 'center',
									fontSize: 17,
									background: "var(--red-color)",
									border: "2px solid var(--red-color)",
									padding: "12px 20px"
								},
							}} 
							show={true}
						>
							<ToggleSwitch
								label={"GST Credit Applicable"} 
								status={credit} 
								callback={(e) => {
                                  setCredit(!credit)
								 getCredit.current = e;
								}}/>
						</Modal> : null
				}  
        {edit && (
           <LineItemModal
            allowTdsAtLineItem={props && props.allowTdsAtLineItem}
            details={props.details}
            dependentmasterValueLineItem={props.dependentmasterValueLineItem && props.dependentmasterValueLineItem[edit.id] ? props.dependentmasterValueLineItem[edit.id] : {}}
            updateLineItemCustomForm={props.updateLineItemCustomForm}
            tenant={tenant}
            edit={edit}
            disableRcm={disableRcm}
            searchProductByService={searchProductByService}
            categoryId={props.data.categoryId}
            onSave={onSaveItem}
            tdsAtLineItem={props.tdsAtLineItem}
            tdsAtLineItemAutomation={(props && props.tdsAtLineItemAutomation)?props.tdsAtLineItemAutomation:undefined}
            tdsAtLineItemInContract={props.tdsAtLineItemInContract}
            vendorId={props.data.vendorId}
            close={() => setEdit(undefined)}
            category={props.data.category}
            contractId={props.data.contractId}
            disableUpdate={disableUpdate}
            tdsSlabs={(props && props.tdsSlabs)?props.tdsSlabs:undefined}
            vendor={(props && props.data && props.data.vendorDetails)?props.data.vendorDetails:undefined}
            />
          )}
        {bulkTds && (
           <BulkTdsLineItem
            items={props.data.table}
            vendorId={props.data.vendorId}
            vendor={(props && props.data && props.data.vendorDetails)?props.data.vendorDetails:undefined}
            tdsSlabs={(props && props.tdsSlabs)?props.tdsSlabs:undefined}
            entityId={(props.details && props.details.entityId)?props.details.entityId:""}
            applying={applyingBulkTds}
            onApply={onApplyBulkTds}
            close={() => { if(!applyingBulkTds) setBulkTds(false) }}
            />
          )}
        {addItem && (
           <AddLineItem
            allowTdsAtLineItem={props && props.allowTdsAtLineItem}
            details={props.details}  
            categoryId={props.data.categoryId}
            tdsAtLineItem={props.tdsAtLineItem}
            tdsAtLineItemAutomation={(props && props.tdsAtLineItemAutomation)?props.tdsAtLineItemAutomation:undefined}
            tdsAtLineItemInContract={props.tdsAtLineItemInContract}
            vendorId={props.data.vendorDetails ? props.data.vendorDetails.id : undefined}
            onSubmit={onAddLineItem}
            bill_to={props.data.bill_to.title||null}
            onClose={() => setAddItem(undefined)} singleLine={props.data.singleLine}
            tdsSlabs={(props && props.tdsSlabs)?props.tdsSlabs:undefined}
            vendor={(props && props.data && props.data.vendorDetails)?props.data.vendorDetails:undefined}
            />
          )}
          {remove ? 
             	<Modal 
						buttonName="Remove"
						onSave={()=>{
                                post(`/vendor/invoicing/${systemInvoiceId}/invoiceItem.remove`, {
                                    "item_id":remove.id
                                }, (e, r) => {
                                    if (r) {
                                        post(`vendor/costAllocation/removeAllocation`,{invoiceId:systemInvoiceId},(e,r)=>{
                                            if(r) {
                                                props.onReload()
                                            } else {
                                                props.onReload()
                                            }
                                        })
                                        showToast({
                                            type: 'success',
                                            message: 'Item Removed successfully'
                                        })
                                    } else if (e) {
                                        handleError(e);
                                    }
                                    setRemove(null)
                                });

							}} 
							title={"Remove Line Item"}
							des="" 
							close={() => {
								setRemove(null)
							}} 
							style={{
								save: {
									width: '100%',
									textAlign: 'center',
									fontSize: 17,
									background: "var(--red-color)",
									border: "2px solid var(--red-color)",
									padding: "12px 20px"
								},
							}} 
							show={remove}
						>
							<div>Are you sure, you want to remove line item?</div>
						</Modal> 
                    : null}

         {deleteAdditionalCharge ?
             <Modal
                 buttonName="Delete"
                 onSave={() => {
                     post(`/vendor/invoicing/${systemInvoiceId}/removeAdditionalCharges`, {
                         "id": deleteAdditionalCharge.id
                     }, (e, r) => {
                         if (r) {
                             showToast({
                                 type: "success",
                                 message: "Additional Charges Deleted Sucessfully"
                             })
                             props.onReload()
                         } else if (e) {
                             handleError(e);
                         }
                         setDeleteAdditionalCharge(null)
                     });
                 }}
                 title={"Remove Additional Charge"}
                 des=""
                 close={() => {
                     setDeleteAdditionalCharge(null)
                 }}
                 style={{
                     save: {
                         width: '100%',
                         textAlign: 'center',
                         fontSize: 17,
                         background: "var(--red-color)",
                         border: "2px solid var(--red-color)",
                         padding: "12px 20px"
                     },
                 }}
                 show={deleteAdditionalCharge}
             >
                 <div>Are you sure, you want to remove additional charge?</div>
             </Modal>
             : null}
            {
                editAdditionalCharge && <EditAdditionalCharge invoiceId={systemInvoiceId} id={editAdditionalCharge.id} onClose={()=>setEditAdditionalCharge()} vendorId={props.data.vendorId} onRealod={props.onReload}/>
            }
            {
                lineItemViolation && !!lineItemViolation.length &&
                <Modal title='Line Item Violation' des='' close={()=>setLineItemViolation()} show={lineItemViolation} hideButton={true}>
                    
                    <ol>
                        {
                            lineItemViolation.map(el => <li style={{marginBottom:5}}>{MISMATCH[el]}</li>)
                        }
                    </ol>
                    
                </Modal>
            }
            {
                lineItemOCRData &&
                <Modal title='Line Item OCR Data' des='' close={() => setLineItemOCRData()} show={lineItemOCRData} hideButton={true}>
                    <ul>
                        {
                            Object.keys(lineItemOCRData).map(key => {
                                if (Array.isArray(lineItemOCRData[key]) || typeof lineItemOCRData[key] === 'object' || ["tableNumber", "uniqueId", "invoiceItemId", "referenceId"].includes(key)) return null;
                                return (
                                    <li style={{ marginBottom: 5 }}>
                                        <div className="flex horizontally space-bw">
                                            <p className='floating-top-label' style={{ color: "var(--secondary-color)" }}>{key}:</p>
                                            <div className="text-truncate flex-1 ml1">{(lineItemOCRData[key]).toString()}</div>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </Modal>
            }
            {
                openTdsDetails &&
                <Modal title='TDS Details' des='' close={()=>setOpenTdsDetails(false)} show={openTdsDetails} hideButton={true}>
                    <div style={{marginTop:'10px'}}>
                        {(openTdsDetails && openTdsDetails.tds && openTdsDetails.tds.tdsAmount)?<p style={{marginBottom:'10px'}}><span style={{fontWeight:'bold'}}>TDS Amount:</span> {openTdsDetails.tds.tdsAmount}</p>:null}
                        {(openTdsDetails && openTdsDetails.tds && openTdsDetails.tds.tdsCode)?<p style={{marginBottom:'10px'}}><span style={{fontWeight:'bold'}}>TDS Code:</span> {openTdsDetails.tds.tdsCode}</p>:null}
                        {(openTdsDetails && openTdsDetails.tds && openTdsDetails.tds.tdsRate)?<p style={{marginBottom:'10px'}}><span style={{fontWeight:'bold'}}>TDS Rate:</span> {openTdsDetails.tds.tdsRate}</p>:null}
                        {(openTdsDetails && openTdsDetails.tds && openTdsDetails.tds.tdsDesc)?<p style={{marginBottom:'10px'}}><span style={{fontWeight:'bold'}}>TDS Desc:</span> {openTdsDetails.tds.tdsDesc}</p>:null}
                        {(openTdsDetails && openTdsDetails.attrs && openTdsDetails.attrs.tds_automation)?<p style={{marginBottom:'10px'}}><span style={{fontWeight:'bold'}}>TDS Automation:</span> {openTdsDetails.attrs.tds_automation}</p>:null}
                    </div>
                </Modal>
            }
            {
                showAiSuggestion &&  
                <AiSuggestions 
                  item={showAiSuggestion}
                  onClose={()=>setShowAiSuggestion(false)}
                  systemInvoiceId={systemInvoiceId}
                  reload={() =>   props.onReload()}
               />
            }
            {
                show3WayMatchingMismatch?
                <Modal show={true} hideButton={true} title='3 Way Mismatch Reason' des='' close={() =>{setShow3WayMatchingMismatch(false)}}>
                    <div>
                        <p>{show3WayMatchingMismatch}</p>
                    </div>
                </Modal>:null
            }
    </div>
 )
}



export default Invoice;

